import axios from '../../../libs/axios_csrf';

const baseGet = async (route, params) => {
  let data = {};
  try {
    data = await axios.get(route, params);
  } catch (error) {
    console.log(error);
  }

  return data;
};

export const bmcPermissions = async id => {
  const { data } = await baseGet(`/bmc_boards/${id}/permissions.json`, {});

  return data;
};

export const currentVProles = async () => {
  const { data } = await baseGet('/value_propositions/curr_vp_roles.json', {});

  return data;
};

export const currentVpPermissions = async () => {
  const { data } = await baseGet(
    '/value_propositions/curr_vp_permissions.json',
    {}
  );

  return data;
};

export const currentFeatures = async () => {
  const { data } = await baseGet('/value_propositions/curr_info.json', {});

  return data;
};

export const getBmcTaskBoardIdBySection = async (id, section) => {
  const { data } = await baseGet(
    `/bmc_boards/${id}/section_task_board_data/${section}.json`,
    {}
  );

  return data;
};
